import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e3ce0f04"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "data-statistic"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "相关数据"), /*#__PURE__*/_createElementVNode("img", {
  class: "line",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202311/6c7a6c4dbecf4b2dba0278914f4df1ce.png",
  alt: ""
})], -1));

const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "num"
};
const _hoisted_6 = {
  class: "label"
};
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const iconList = ref(['https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202311/6132c4889904471eb615e31429ea69c0.png', 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202311/d28ff93545c54f78a5ebc5285c3dac0e.png', 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202311/804459a8c23f40e0ad4be7c96c6c41ba.png', 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202311/0c88cbec132b49618eb7822f641cba40.png']);
    const list = ref([]);

    const getData = async () => {
      const params = {
        num: props.menu.num
      };
      const res = await $http.getTeachData(params);
      list.value = res;
    };

    getData();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "data-item"
        }, [_createElementVNode("img", {
          class: "icon",
          src: iconList.value[index],
          alt: ""
        }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(item.num), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)]);
      }), 128))])]);
    };
  }

};